module.exports = __webpack_public_path__ + "img/design-process.b24f9f29.svg";